import {NgModule} from '@angular/core';
import {ValgButtonDirective} from "./button.directive";
import {ValgDebounceButtonDirective} from "./debounce-button.directive";


@NgModule({
    declarations: [
        ValgButtonDirective,
        ValgDebounceButtonDirective
    ],
    exports: [
        ValgButtonDirective,
        ValgDebounceButtonDirective
    ]
})
export class ButtonModule {}
